import { Filter } from "components/atoms/Filter";
import Container from "components/atoms/layout/Container/Container";
import { ExportSelected } from "components/layouts/exportSelected";
import { DatabaseHeader } from "components/modules/Database/components/header";
import { Footer } from "components/molecules/TableFooter";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { TableDatabase } from "./components/table";
import { usePulse } from "./model/usePulse";
import { useEffect } from "react";
import { setCurrentPage } from "store/slices/ui.slice";
import BulkSearch from "components/molecules/BulkSearch/BulkSearch";

export const DatabaseModule = () => {
  const { filters, pageSize } = usePulse();
  const { ui } = useAppSelector((state) => state);
  const { searchMain } = useAppSelector((state) => state);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setCurrentPage("database"));
  }, []);

  return (
    <Container
      direction="row"
      className="flex flex-1 gap-5 flex-row  overflow-hidden"
    >
      <div
        className={`flex py-4 px-5 flex-1 gap-5 overflow-hidden ${
          ui.filterOpen ? "flex-row" : "flex-col"
        }`}
      >
        <Filter filters={filters} />
        <div className="flex flex-col h-full overflow-hidden w-full border border-gray-700 rounded-2xl">
          <DatabaseHeader />
          <TableDatabase />
          <Footer totalItems={searchMain.count} pageSize={pageSize} />
        </div>
      </div>
      {ui.exportOpen ? <ExportSelected /> : null}
      {ui.bulkSerch ? <BulkSearch /> : null}
    </Container>
  );
};
